import {useTranslation} from "react-i18next";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {DownloadPdfIcon} from "@ui/icons/icons";
import {addLoadingBody, removeLoadingBody} from "@helpers/loadingHandler";
import {generatePdfFile} from "@containers/export/containers/pdf/helpers/generatePdfFile";
import {IExportDataSetAdditionalItem} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {HeadColumns} from "@ui/tableCustom/types/table";
import {ExportPdfContent, IExportPdfBaseSettings} from "@containers/export/containers/pdf/types";


interface IProps<T> {
    fileName?: string,
    onDownload?: () => void,
    baseSettings?: IExportPdfBaseSettings,
    baseSettingsCb?: (columns: IColumnItem<T>[]) => IExportPdfBaseSettings,
    headerContents?: ExportPdfContent,
    columnExport: IColumnItem<T>[],
    fullColumns: IColumnItem<T>[],
    headColumns?: HeadColumns<T>,
    exportDataFromAllPage?: boolean,
    data: T[],
    additionalDataSet: IExportDataSetAdditionalItem<T>[],
    ignoredExportColumnKey?: string | null,
    order: keyof T | false,
    direction: string,
    allData?: T[],
    exportFromAllColumns?:boolean,

}

function ExportPdf<T>({
                          fileName,
                          onDownload,
                          baseSettings,
                          baseSettingsCb,
                          headerContents,

                          columnExport,
                          fullColumns,
                          headColumns,
                          exportDataFromAllPage,
                          allData,
                          data,
                          additionalDataSet,
                          order,
                          direction,
                          exportFromAllColumns,
                      }: IProps<T>) {

    const {t} = useTranslation()

    const download = async () => {
        const currentLengthData = allData && exportDataFromAllPage ? allData.length : data.length;
        if (currentLengthData < 250) {
            await generatePdfFile<T>({
                fileName,
                onDownload,
                baseSettings,
                baseSettingsCb,
                headerContents,

                columnExport,
                fullColumns,
                headColumns,
                exportDataFromAllPage,
                allData,
                data,
                additionalDataSet,
                order,
                direction,
                t,
                exportFromAllColumns,
            })
            return
        }

        addLoadingBody({label: t('base.waitGeneratePdf')})
        setTimeout(async () => {
            await generatePdfFile<T>({
                fileName,
                onDownload,
                baseSettings,
                baseSettingsCb,
                headerContents,

                columnExport,
                fullColumns,
                headColumns,
                exportDataFromAllPage,
                allData,
                data,
                additionalDataSet,
                order,
                direction,
                t,
                exportFromAllColumns,
            })
            removeLoadingBody()
        }, 100)

    }
    return (
        <IconButtonCustom
            tooltip={t('exportPdf')}
            onClick={download}
            variant={'empty'}
        >
            <DownloadPdfIcon/>
        </IconButtonCustom>
    );
};

export default ExportPdf;